import { useContext } from 'react';
import { UnifiedProfilesActionsContext } from './context';

export const useUnifiedProfilesActions = () => {
  const context = useContext(UnifiedProfilesActionsContext);
  if (!context) {
    throw new Error('useUnifiedProfilesActions must be used within a UnifiedProfilesProvider');
  }

  return context;
};
